import { useFormContext } from "react-hook-form";

import Box from "ds/components/Box";
import KeyValue from "components/KeyValue";
import Tag from "ds/components/Tag";
import ListEntitiesItemDescription from "components/ListEntitiesItem/Description";

import { ContextFormFields } from "../types";
import NewContextSummaryPanel from "./Panel";
import { ContextCreationWizardStep } from "../constants";

const NewContextSummaryDetails = () => {
  const { getValues } = useFormContext<ContextFormFields>();
  const formValues = getValues();

  return (
    <NewContextSummaryPanel name="Details" step={ContextCreationWizardStep.Details}>
      <Box direction="column">
        <KeyValue name="Name">
          {formValues.contextName}
        </KeyValue>
        <KeyValue name="Space">{formValues.space}</KeyValue>
        {formValues.description && (
          <KeyValue name="Description" align="center">
            <ListEntitiesItemDescription noPadding description={formValues.description} />
          </KeyValue>
        )}
        <KeyValue name="Labels">
          {formValues.labels.length && (
            <Box gap="medium" justify="end" wrap>
              {formValues.labels.map(({ value }, i) => (
                <Tag tag={value} key={i} withAutoAttach />
              ))}
            </Box>
          )}
        </KeyValue>
      </Box>
    </NewContextSummaryPanel>
  );
};

export default NewContextSummaryDetails;
